import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { GiftcardDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchGiftcardPlans } from "../../../../features/auth/store/giftcardPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import Giftcard from "./Giftcard";
import { fetchGiftcardCategories } from "../../../../features/auth/store/giftcardCategorySlice";
import { SortBy, SortOrder } from "../../../../features/auth/store/types/types";

const GiftcardRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [categoryFilter, setCategoryFilter] = useState<string>("");
  const [countryFilter, setCountryFilter] = useState<string>("");
  const [sortBy, setSortBy] = useState<SortBy | "">("created_at");
  const [sortOrder, setSortOrder] = useState<SortOrder | "">("desc");
  const [selectedGiftcardPlan, setSelectedGiftcardPlan] =
    useState<Product | null>(null);
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { giftcardPlans, loading, error } = useSelector(
    (state: RootState) => state.giftcardPlans,
  );

  const { giftcardCategories } = useSelector(
    (state: RootState) => state.giftcardCategories,
  );

  const isMounted = useRef(false);

  useEffect(() => {
    if (!giftcardCategories || giftcardCategories.length == 0) {
      dispatch(fetchGiftcardCategories({ perPage: 40 }));
    }
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      dispatch(fetchGiftcardPlans({}));
      return;
    }
    const handler = setTimeout(() => {
      const filters: Record<string, any> = {};

      if (statusFilter) filters.status = statusFilter;
      if (categoryFilter) filters.category = categoryFilter; // ID sent
      if (countryFilter) filters.country = countryFilter; // ID sent
      if (sortBy) filters.sort_by = sortBy;
      if (sortOrder) filters.sort_order = sortOrder;
      if (searchTerm.trim()) filters.search = searchTerm.trim();

      dispatch(fetchGiftcardPlans(filters));
    }, 350);

    return () => clearTimeout(handler);
  }, [
    dispatch,
    statusFilter,
    categoryFilter,
    countryFilter,
    sortBy,
    sortOrder,
    searchTerm,
  ]);

  // Transform GiftcardPlan to Product - ensuring all required fields are present

  const handleGiftcardPlanClick = (giftcardPlan: Product) => {
    setSelectedGiftcardPlan(giftcardPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedGiftcardPlan(null);
  };

  if (showDetailView && selectedGiftcardPlan) {
    return (
      <GiftcardDetailView
        giftcardPlan={{
          ...selectedGiftcardPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <Giftcard
      giftcardPlans={giftcardPlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onGiftcardPlanClick={handleGiftcardPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      categoryFilter={categoryFilter}
      setCategoryFilter={setCategoryFilter}
      countryFilter={countryFilter}
      setCountryFilter={setCountryFilter}
      sortBy={sortBy}
      setSortBy={setSortBy}
      sortOrder={sortOrder}
      setSortOrder={setSortOrder}
    />
  );
};

export default GiftcardRouter;
